import angular from 'angular';
import fp from 'micro-fp';

export default function possessive(Utils) {
  'ngInject';

  const maybeMap = function maybeMap(property) {
    return property ? fp.map(fp.prop(property)) : fp.id;
  };

  const sort = (arg) => arg.sort();

  const maybeArrayToString = fp.curry((property, arrayOrString) => {
    if (angular.isArray(arrayOrString)) {
      return fp.compose(Utils.addJoin, sort, maybeMap(property))(arrayOrString);
    }

    return arrayOrString;
  });

  function addSuffix(string) {
    if (!string) {
      return string;
    }

    return /s$/i.test(string) ? `${string}'` : `${string}'s`;
  }

  return function link(input, property) {
    if (!input) {
      return input;
    }

    return fp.compose(addSuffix, maybeArrayToString(property))(input);
  };
}
